import { useState, useEffect } from 'react';
import i18n from 'i18next';
import {getNewsAPIUrl} from "../constants";

const parseNewsDate = (value) => {
    if (!value) {
        return 0;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

const sortNewsByLatest = (items = []) => (
    [...items].sort((a, b) => {
        const dateDiff = parseNewsDate(b?.date) - parseNewsDate(a?.date);

        if (dateDiff !== 0) {
            return dateDiff;
        }

        return 0;
    })
);

const useFetchNews = (language) => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchNews = async () => {
        try {
            const response = await fetch(getNewsAPIUrl(language));
            const json = await response.json();
            setNews(sortNewsByLatest(json));
        } catch (e) {
            // Handle error
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNews();
    }, [language]); // Dependency on language

    return { news, loading };
};

export default useFetchNews;
